import React from 'react'
import { EcoMasterIcon, EcoStoreIcon, EditIcon, PersonIcon } from '../../../assets/icons'
import { useHistory } from "react-router-dom";
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import Card from '../../../utils/components/CardInventory/CardInventory'


const CertificateMenu = () => {
    const history = useHistory();
    return (
        <div className='container-page scroll-menu'>
            <TitleSVG Icon={EditIcon}
                titleHighlight={'Solicitudes'}
                title={' de elevación de usuario'}
            />
            <div className="parent-width wrap centerContent align-space-around height-menu-content">
                <Card
                    hasOnClick={true}
                    text={'Validar usuarios'}
                    onClick={() => { history.push('/Admin/CertificateStateConceptAdmin') }}
                    Icon={PersonIcon}
                    iconClass={'stroke-secondary-color fill-none'}
                    iconClassHover={'stroke-white fill-none'}
                />

                <Card
                    hasOnClick={true}
                    text={'Solicitudes de ser Ecomaster'}
                    onClick={() => { history.push('/Admin/TobeRepresentativeList') }}
                    Icon={EcoMasterIcon}
                    iconClass={'fill-secondary-color '}
                    iconClassHover={'fill-white'}
                />

                <Card
                    hasOnClick={true}
                    text={'Solicitudes de ser Ecotienda'}
                    onClick={() => { history.push('/Admin/TobeFranchiseList') }}
                    Icon={EcoStoreIcon}
                    iconClass={'fill-secondary-color'}
                    iconClassHover={'fill-white'}
                />
            </div>


        </div>
    )
}

export default CertificateMenu